export default __webpack_public_path__ + "static/char-s-sp03-ko-7a29fcf1fa9a8b294a88d72b331cb839.png";